/* Pohyblivé pásy fotiek a recenzií ([data-th-marquee], Splide AutoScroll).
   data-speed = px za snímku; kladné = doľava, záporné = doprava.
   Pás sa zapne až keď je blízko obrazovky a mimo nej stojí – inak by zbytočne vyťažoval procesor (rýchlosť stránky). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  var playIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var s = e.target._thSplide;
      var as = s && s.Components && s.Components.AutoScroll;
      if (!as || reduce) return;
      if (e.isIntersecting) as.play(); else as.pause();
    });
  }, { rootMargin: '100px 0px' }) : null;

  function mount(el) {
    if (el._thSplide || typeof window.Splide === 'undefined') return;
    var speed = parseFloat(el.getAttribute('data-speed') || '0.6');
    var splide = new window.Splide(el, {
      type: 'loop',
      drag: 'free',
      autoWidth: true,
      arrows: false,
      pagination: false,
      gap: '16px',
      clones: 8,
      breakpoints: { 1023: { gap: '12px' } },
      autoScroll: { speed: reduce ? 0 : speed, pauseOnHover: true, pauseOnFocus: false }
    });
    splide.on('drag', function () { el.classList.add('is-dragging'); });
    splide.on('dragged', function () { el.classList.remove('is-dragging'); });
    splide.mount(window.splide && window.splide.Extensions ? window.splide.Extensions : {});
    el._thSplide = splide;
    if (playIO) playIO.observe(el);
  }

  var nearIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      nearIO.unobserve(e.target);
      mount(e.target);
    });
  }, { rootMargin: '400px 0px' }) : null;

  function init() {
    document.querySelectorAll('[data-th-marquee]').forEach(function (el) {
      if (el._thSplide || el._thWatched) return;
      el._thWatched = true;
      if (nearIO) nearIO.observe(el); else mount(el);
    });
  }

  window.thrivoInitMarquees = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* editor témy: po úprave sekcie sa jej HTML vymení */
  document.addEventListener('shopify:section:load', init);
})();
